export const environment = {
  production: true,
  urlApi: '',
  googleMapApiKey: 'AIzaSyBUz_MhSO1wLjqJSgSMcfYER34VBTja3ao',
  sentryEnable: true,
  sentryEnv: 'prod',
  sentryDns: 'https://4830367fa9a0475e407df37dee94ea46@o4506593468547072.ingest.us.sentry.io/4508777386737664',
  geoApi: 'https://www.geo.api.gouv.fr/',
  cartoIgnApi: 'https://apicarto.ign.fr/',
};
